import { apiWrapper } from 'ccs-ui-components';
import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { ISourceRegistryRequestModel, ISourceRegistryResponseModel } from '../../../models/index';
import { createSourceRegistryResponseSchema } from '../../../utilities/sources/RegistriesSchemaDefintion';
import { createSourceRegistry } from '../../actions/actionType/sources/SourceRegistryActionTypes';
import {
  clearedSourceRegistrys,
  createSourceRegistryStart,
  createdSourceRegistryFailure,
  createdSourceRegistrySuccess
} from '../../actions/sagaActions/sources/CreateSourceRegistrySagaActions';
import { CreateSourceRegistryFailurePayload, CreateSourceRegistryRequest } from '../../actions/types/sources/CreateSourceRegistryTypes';

const headersInstance = () => ({
  'Ocp-Apim-Subscription-Key':
    process.env.REACT_APP_API_OCP_APIM_SUBSCRIPTION_KEY ?? ''
});
/**
 * Call Gets SourceRegistrys by ID API
 * @param sourceRegistryName : string
 * @returns api response
 */
export async function callCreateSourceRegistryApi(sourceRegistryData: ISourceRegistryRequestModel) {
  return apiWrapper.post<ISourceRegistryResponseModel>(
    `${process.env.REACT_APP_API_CONTROL_PLANE_BASE_URL}/sources`,
    [sourceRegistryData],
    headersInstance()
  );
}
/**
 * Saga to get SourceRegistry by sourceRegistryName
 * @param sourceRegistryDatae:object
 */
export function* createSourceRegistryData({ sourceRegistryData }: CreateSourceRegistryRequest) {
  yield put(clearedSourceRegistrys());
  yield put(createSourceRegistryStart());
  try {
    const { responseBody: sourceRegistryResponseData, isError, error } = yield call(callCreateSourceRegistryApi, sourceRegistryData);
    if (isError) {
      throw error;
    }
    const resValidity = createSourceRegistryResponseSchema.validate(sourceRegistryResponseData, { abortEarly: true });
    if (sourceRegistryResponseData) {
      if (resValidity.error) {
        throw new Error('No Response');
      } else {
        yield put(createdSourceRegistrySuccess(sourceRegistryResponseData));
      }
    }
  } catch (error: any) {
    const obj: CreateSourceRegistryFailurePayload = {
      errorCode: error?.response?.data?.errorCode,
      errorMessage: error?.response?.data?.errorMessage,
      timestamp: error?.response?.data?.timestamp,
    };
    yield put(createdSourceRegistryFailure(obj));
  }
}

/**
 * Saga Effect to consider latest request
 */
export function* createSourceRegistrySaga() {
  yield takeLatest(createSourceRegistry.CREATE_SOURCE_REGISTRY_REQUEST, createSourceRegistryData);
}

export const createNewSourceRegistrySaga = [fork(createSourceRegistrySaga)];
